import React from 'react';
import { Box, Typography, Button, Paper, Modal } from '@mui/material';
import { FaExclamationTriangle } from 'react-icons/fa';
import './EmailRegistrationModal.css';

const EmailRegistrationModal = ({ open, email, onboardingUrl }) => {
  const handleRegisterClick = () => {
    window.open(onboardingUrl, '_blank');
  };

  return (
    <Modal
      open={open}
      disableEscapeKeyDown={true}
      aria-labelledby="email-registration-modal-title"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(4px)',
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
      }}
    >
      <Paper
        elevation={24}
        sx={{
          maxWidth: 520,
          width: '90%',
          padding: 4,
          borderRadius: 3,
          textAlign: 'center',
          backgroundColor: '#ffffff',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          animation: 'slideIn 0.3s ease-out'
        }}
      >
        {/* Warning Icon */}
        <Box sx={{ mb: 2 }}>
          <FaExclamationTriangle
            style={{
              fontSize: 64,
              color: '#FF9800',
              filter: 'drop-shadow(0 2px 8px rgba(255, 152, 0, 0.3))'
            }}
          />
        </Box>

        {/* Title */}
        <Typography
          id="email-registration-modal-title"
          variant="h5"
          component="h2"
          sx={{
            fontWeight: 700,
            color: '#003087',
            mb: 2
          }}
        >
          Symphony Summit Registration Required
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          sx={{
            color: '#666666',
            mb: 5,
            lineHeight: 1.6
          }}
        >
        Please register your <strong>Symphony Summit email</strong> to continue using the Test Data Bot.
        Your registration will be verified by the team before you can proceed.
        </Typography>

        {/* Register Button */}
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={handleRegisterClick}
          sx={{
            height: 48,
            fontSize: '1rem',
            fontWeight: 600,
            borderRadius: 2,
            textTransform: 'none',
            background: 'linear-gradient(135deg, #FFCC00 0%, #FFB800 100%)',
            color: '#003087',
            boxShadow: '0 4px 12px rgba(255, 204, 0, 0.4)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              background: 'linear-gradient(135deg, #FFD633 0%, #FFCC00 100%)',
              boxShadow: '0 6px 16px rgba(255, 204, 0, 0.5)',
              transform: 'translateY(-2px)'
            },
            '&:active': {
              transform: 'translateY(0)',
              boxShadow: '0 2px 8px rgba(255, 204, 0, 0.4)'
            }
          }}
        >
          Register Symphony Summit Email
        </Button>

        {/* Help Text */}
        <Typography
          variant="caption"
          sx={{
            color: '#999999',
            fontSize: '0.75rem',
            display: 'block',
            textAlign: 'center',
            mt: 2,
            lineHeight: 1.4
          }}
        >
          This will open the registration page in a new tab.<br />
          Your email will be verified by the team before approval.<br />
          Please check back later once your registration has been approved.
        </Typography>
      </Paper>
    </Modal>
  );
};

export default EmailRegistrationModal;
